var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPencil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.9999C17.2547 2.69894 17.5697 2.45396 17.925 2.28059C18.2803 2.10721 18.6681 2.00924 19.0636 1.99292C19.4592 1.9766 19.8538 2.04228 20.2224 2.18579C20.5909 2.3293 20.9254 2.54748 21.2043 2.82642C21.4833 3.10537 21.7006 3.43897 21.8425 3.80595C21.9845 4.17292 22.0478 4.56524 22.0286 4.95788C22.0094 5.35053 21.908 5.73489 21.7309 6.08647C21.5538 6.43805 21.3049 6.74914 21 6.9999L7.5 20.4999L2 21.9999L3.5 16.4999L17 2.9999Z",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5L19 9",
    stroke: "#333335",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil.167b7fcd.svg";
export { ForwardRef as ReactComponent };